/**
 * A home a logged-out buyer tried to save, held across the sign-up round trip.
 *
 * Router state alone is not enough: signing up leaves the app entirely for the
 * verification email, so the id has to survive in localStorage. It is stamped,
 * because a heart tapped last month should not silently save a home the next
 * time this browser signs in.
 *
 * Shared by the browse page and the listing detail page, which both offer the
 * same heart to the same logged-out visitor.
 */
const PENDING_SAVE_KEY = 'pending_save_listing_id';
const PENDING_SAVE_TTL_MS = 24 * 60 * 60 * 1000;

export const rememberPendingSave = (id) => {
  try { localStorage.setItem(PENDING_SAVE_KEY, JSON.stringify({ id, ts: Date.now() })); } catch { /* private mode: the router-state path still works */ }
};

export const readPendingSave = () => {
  let raw = null;
  try { raw = localStorage.getItem(PENDING_SAVE_KEY); } catch { return null; }
  if (!raw) return null;
  try {
    const { id, ts } = JSON.parse(raw);
    return id && ts && Date.now() - ts < PENDING_SAVE_TTL_MS ? id : null;
  } catch { return null; }
};

export const forgetPendingSave = () => {
  try { localStorage.removeItem(PENDING_SAVE_KEY); } catch { /* nothing to clean up */ }
};
